import { useAemConfig } from '@as-react/common-components';
import { searchQueries } from '@as-react/common-queries';
import { useTranslation } from 'react-i18next';
import { DELAY } from '../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { getSearchBrandAsCategories, getSearchBrands, getSearchCategories, getSearchContent, getSearchKeywords, getSearchItemGrouping, getSearchResultLimit, } from '../util/SearchUtil';
import { useDebouncedQuery } from './useDebouncedQuery';
export const useMenuSearch = ({ searchTerm = '', suggestionsParentLink, brandsParentLink, categoriesParentLink, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    const aemConfiguration = useAemConfig();
    const { defaultRequestParams, servicesEndpoint } = aemConfiguration;
    const elasticsearchIndex = `${aemConfiguration.activeEnvironment}_${aemConfiguration.elasticsearchIndex}`;
    const searchResultLimit = getSearchResultLimit(searchTerm);
    const { getSearchSuggestions, getSearchContentSuggestion } = searchQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { data: suggestions } = useDebouncedQuery(getSearchSuggestions({ query: searchTerm }, {
        enabled: Boolean(searchTerm),
        retry: false,
        placeholderData: prev => prev,
        select: data => ({
            keywords: getSearchKeywords(data === null || data === void 0 ? void 0 : data.keywords, suggestionsParentLink),
            brands: getSearchBrands(data === null || data === void 0 ? void 0 : data.brands, brandsParentLink),
            categories: getSearchCategories(data === null || data === void 0 ? void 0 : data.categories, categoriesParentLink),
            brandAsCategories: getSearchBrandAsCategories(data === null || data === void 0 ? void 0 : data.brandAsCategories, categoriesParentLink),
        }),
    }), DELAY.DELAY_250);
    const { data: contentSuggestions } = useDebouncedQuery(getSearchContentSuggestion({ query: searchTerm, elasticsearchIndex }, {
        enabled: Boolean(searchTerm),
        retry: false,
        placeholderData: prev => prev,
        select: data => ({ content: getSearchContent(data === null || data === void 0 ? void 0 : data.content) }),
    }), DELAY.DELAY_250);
    const menuSearchItemGrouping = getSearchItemGrouping(Object.assign(Object.assign({}, suggestions), contentSuggestions), searchResultLimit, t);
    return {
        menuSearchItemGrouping,
        suggestions,
        contentSuggestions,
    };
};
